import type React from 'react'
import { useState, useEffect } from 'react'
// eslint-disable-next-line no-restricted-imports -- use datadog and rollbar directly
import logging from 'shared/utils/logging'
import lazyRetry from 'shared/utils/lazyRetry'
import { useTitle } from 'react-use'
import Api from './Api'
import { SurveyPageEnum } from './types'

const SurveyPage = lazyRetry(() => import('./SurveyPage'))
const ThankYou = lazyRetry(() => import('./ThankYou'))

const Survey: React.FC = () => {
  const gonSurveyPage = window?.gon?.survey_page as SurveyPageEnum
  const gonJobId = window?.gon?.job_id
  const gonToken = window?.gon?.token
  const [page, setPage] = useState<SurveyPageEnum>(gonSurveyPage || SurveyPageEnum.SURVEY)
  const [pageIndex, setPageIndex] = useState<number>(0)
  useTitle(page === SurveyPageEnum.SURVEY ? 'Survey' : 'Thank You')

  useEffect(() => {
    void logging.track('Visited NPS Survey', {
      job_id: gonJobId,
    })

    if (gonToken) {
      Api.setBearerToken(gonToken)
    }
  }, [gonJobId, gonToken])

  const handleSetPage = (newPage: SurveyPageEnum, newIndex?: number) => {
    setPage(newPage)
    setPageIndex(newIndex || 0)
  }

  if (page === SurveyPageEnum.SURVEY) {
    return <SurveyPage pageIndex={pageIndex} setPage={handleSetPage} />
  }

  return <ThankYou />
}

export default Survey
